export default "__VITE_ASSET__DzB_KxYk__"